import { render } from "./imagenprimera_ingles.vue?vue&type=template&id=11d2cb9c&scoped=true"
import script from "./imagenprimera_ingles.vue?vue&type=script&lang=js"
export * from "./imagenprimera_ingles.vue?vue&type=script&lang=js"

import "./imagenprimera_ingles.vue?vue&type=style&index=0&id=11d2cb9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d2cb9c"]])

export default __exports__